//src/app/routes/BillingRoutes.tsx
import Billing from 'app/features/billing/BillingComponent';
import { Route } from 'react-router-dom';

export default function BillingRoutes() {
  return <Route path="billing" element={<Billing />} />;
}
